import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Row, Col, Spinner, Form, Button } from "react-bootstrap";
import Card from "../../components/Card";
import MasterService from "../../services/master/MasterService";
import DataTable from "react-data-table-component";

const Hs = () => {
    const columns = [
        {
            name: 'ID',
            cell: row => row['id'],
            grow: 0.1
        },
        {
            name: 'Kode HS',
            cell: row => row['kodeHs'],
            grow: 0.5
        },
        {
            name: 'Uraian',
            cell: row => row['uraian']
        },
        {
            name: 'Uraian Indonesia',
            cell: row => row['uraianId']
        },
        {
            name: 'Tahun',
            cell: row => row['tahun'],
            grow: 0.1
        }
    ]

    const masterService = useMemo(() => new MasterService(), []);

    const [listHs, setListHs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchKeyword, setSearchKeyword] = useState("");
    const [page, setPage] = useState(0);
    const [size, setSize] = useState(10);

    const fetchListHs = useCallback(async () => {
        setLoading(true);
        try {
            const res = await masterService.listHs(null, null, 0, 1000); 
            setListHs(res.data.data);
        } catch (err) {
            console.error("Gagal ambil data HS", err);
            setListHs([]);
        } finally {
            setLoading(false);
        }
    }, [masterService]);

    useEffect(() => {
        fetchListHs();
    }, [fetchListHs]);

    const filteredData = useMemo(() => {
        const keyword = searchKeyword.toLowerCase();
        return listHs.filter((row) =>
            (row.kodeHs || "").toLowerCase().includes(keyword) ||
            (row.uraian || "").toLowerCase().includes(keyword) ||
            (row.uraianId || "").toLowerCase().includes(keyword)
        );
    }, [listHs, searchKeyword]);

    const paginatedData = useMemo(() => {
        const start = page * size;
        return filteredData.slice(start, start + size);
    }, [filteredData, page, size]);

    return (
        <Row>
            <Col sm="12">
                <Card>
                    <Card.Header className="d-flex justify-content-between">
                        <div className="header-title">
                            <h4 className="card-title">Pencarian Data</h4>
                        </div>
                    </Card.Header>
                    <Card.Body>
                        <Form>
                            <Row className="align-items-end">
                                <Col sm="3">
                                    <Form.Group>
                                        <Form.Control
                                            type="text"
                                            placeholder="Cari Kode HS / Uraian"
                                            value={searchKeyword}
                                            onChange={(e) => setSearchKeyword(e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm="2">
                                    <Button
                                        variant="secondary"
                                        className="w-100"
                                        onClick={() => setSearchKeyword("")}
                                    >
                                        Reset
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>
                <Card>
                    <Card.Header className="d-flex justify-content-between">
                        <div className="header-title">
                            <h4 className="card-title">Daftar Master HS</h4>
                        </div>
                    </Card.Header>
                    <Card.Body>
                        <div className="table-responsive border-bottom my-3">
                            {loading ? (
                                <Spinner animation="border" />
                            ) : (
                                <DataTable
                                    columns={columns}
                                    data={paginatedData}
                                    highlightOnHover
                                    pagination
                                    paginationServer
                                    paginationTotalRows={filteredData.length}
                                    paginationPerPage={size}
                                    onChangePage={(newPage) => setPage(newPage - 1)}
                                    onChangeRowsPerPage={(newSize) => {
                                        setSize(newSize);
                                        setPage(0);
                                    }}
                                    persistTableHead
                                    customStyles={{
                                        headCells: {
                                            style: {
                                                backgroundColor: "#00acee",
                                                color: "white",
                                            },
                                        },
                                    }}
                                />
                            )}
                        </div>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
};

export default Hs;
